import React from 'react'
import { makeStyles } from '@material-ui/core'
import SectionScreen from '../../SectionScreen'
import { useWealthOwnerDetails } from '../../ClientDetailsFormContext'
import SectionHeader from '../../../shared/SectionHeader'
import PersonalSpace from '../../../shared/PersonalSpace'
import { useWealthOwnerStatusSummary } from '../../../../../../api/users'
import InviteAction from './InviteAction'
import ResetUserAction from './ResetUserAction'
import ResetAuthAction from './ResetAuthAction'

const useStyles = makeStyles((theme) => ({
  userInfoSection: {
    position: 'relative',
    padding: '10px'
  },
  actions: {
    '& > *': {
      marginBottom: theme.layout.margin.thick,
      border: 'var(--border-neutral-thin)',
      borderRadius: 'var(--border-radius-md)',
      padding: theme.layout.padding.medium
    },
    '& .__row': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '20px',
      marginBottom: '20px'
    },
    '& .__disabled': {
      color: 'var(--color-neutral-700)'
    }
  }
}))

function WealthOwnerActionsSection () {
  const classes = useStyles()
  const { wealthOwner } = useWealthOwnerDetails()
  const { data: status, isLoading } = useWealthOwnerStatusSummary(wealthOwner.userId)

  return (
    <SectionScreen sectionName='user_actions' className={classes.userInfoSection}>
      <SectionHeader text='Actions' />
      <div className={classes.actions}>
        <InviteAction wealthOwner={wealthOwner} isLoading={isLoading} status={status?.statusSummary?.status} />
        <ResetUserAction wealthOwner={wealthOwner} isLoading={isLoading} status={status?.statusSummary?.status} />
        <ResetAuthAction user={wealthOwner} isLoading={isLoading} />
      </div>
      <PersonalSpace />
    </SectionScreen>
  )
}

export default WealthOwnerActionsSection
